import appAxios from '../../utils/appAxios.js';
export default {
    namespaced: true,

    state: {
        customer: {
            ID: "",
            companyName: "",
            personelFName: "",
            personelLName: "",
            personelEmail: "",
            companyPhone: "",
            adres: {
                country: "",
                city: "",
                district: "",
                openAdress: "",
            },
            description: "",
        },
        customerList: [],
        totalRecords: 0,
        loading: false,
    },
    getters: {
        _getCustomer: (state) => { return state.customerList },
        _getTotalRecords: (state) => { return state.totalRecords },
        _getLoading: (state) => { return state.loading }
    },
    mutations: {
        SET_CUSTOMER_LIST(state, Data) {
            state.customerList = []
            state.totalRecords = Data.TotalItemsCount
            if (Data.ListItems.length > 0) {
                Data.ListItems.forEach(item => {
                    state.customerList.push(item)
                });
            }
            state.loading = false
        }
    },
    actions: {
        async GET_COMMONN_CUSTOMERS() {
            return new Promise((resolve) => {
                appAxios.get("/common/getCustomers").then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data.map(customer => ({ Id: Number(customer.Id), Value: customer.Value })))
                    }
                    else {
                        resolve([])
                    }
                })
            })

        },

        async GET_CUSTOMER(_, payload) {
            return new Promise(resolve => {
                appAxios.get(`/admin/customer/get/${payload}`).then(response => {
                    if (response.data.Success) {
                        resolve(response.data.Data)
                    }
                    else {
                        resolve(null)
                    }
                }).catch(() => resolve(null))
            })
        },

        async GET_ALL_CUSTOMERS({ commit, state }, payload) {
            state.loading = true
            await appAxios.post("/admin/customer/getall", payload).then(response => {
                if (response.data.Success) {
                    commit("SET_CUSTOMER_LIST", response.data.Data)
                }
            }).catch(() => state.loading = false)
        },

        async ADD_CUSTOMER(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/customer/create", payload).then(response => {
                    resolve(response.data.Success)
                }).catch(() => resolve(false))
            })

        },

        async UPDATE_CUSTOMER(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/customer/update", payload).then(response => {
                    resolve(response.data.Success)
                }).catch(() => resolve(false))
            })
        },

        async DELETE_CUSTOMER({ dispatch }, payload) {
            await appAxios.post("/admin/customer/delete", payload[0]).then(response => {
                if (response.data.Success) {
                    dispatch("GET_ALL_CUSTOMERS", payload[1])
                }
            })

        },

        async SET_CUSTOMER_LOGO(_, payload) {

            return new Promise(resolve => {
                let responseStatus = false
                appAxios.post('/admin/Customer/UploadLogoPicture', payload).then(response => {
                    responseStatus = response.data.Success
                }).catch(() => responseStatus = false).finally(() => resolve(responseStatus))

            })

        },
        async DELETE_CUSTOMER_LOGO(_, payload) {

            return new Promise(resolve => {
                let responseStatus = false
                appAxios.get(`/admin/Customer/DeleteLogoPicture?customerId=${payload}`).then(response => {
                    responseStatus = response.data.Success
                }).catch(() => responseStatus = false).finally(() => resolve(responseStatus))
            })
        },

        async UPDATE_CUSTOMER_PUBLISHED(_, payload) {
            return new Promise(resolve => {
                appAxios.post("/admin/Customer/UpdatePublished", payload).then(response => {
                    resolve(response.data.Success)
                }).catch(() => resolve(false))
            })
        }

    }

}